<template>
  <div>
    <div class="about-title">
      <h1 class="title-main">ABOUT</h1>
      <p class="title-sub">セルフエステエンリケについて</p>
    </div>
    <div class="about-container">
      <div v-bind:class=content.contentClass v-for="content in aboutEnrikeFull" :key="content.title">
        <img v-bind:class=content.imgClass :src=content.imgPath :alt=content.imgTitle>
        <div v-bind:class=content.textContentClass>
          <p class="about-text-title"><span v-html=content.title /></p>
          <p><span v-html=content.textContent /></p>
        </div>
      </div>
    </div>
    <ToFC class="margin-tb-50" />
  </div>
</template>

<script>
import ToFC from '../../components/ToFC.vue'

export default {
  name: 'app',
  components: {
    ToFC,
  },
  data:function(){
    return {
      aboutEnrike:[
        {
          //imgPath:require('./img/about_img1.png'),
          imgPath:require('./img/about-1.png'),
          imgTitle:'セルフエステエンリケとは',
          //title:'セルフエステエンリケとは',
          textContent:`エステって高いし、時間もかかるし
気軽に通えない。だから、エンリケが
「安くて早くて手軽」なエステを作りました！
それがセルフエステエンリケ。`
        },
        {
          //imgPath:require('./img/about_img2.png'),
          imgPath:require('./img/about-2.png'),
          imgTitle:'好きな部分に好きなだけ',
          //title:'好きな部分に好きなだけ',
          textContent:`太ももの内側だけすごく気になるけど、エステだと他の部分もやらなきゃいけないし...。
そんな心配ご無用！気になる部位だけ好きなだけ施術が可能！`
        },
        {
          //imgPath:require('./img/about-3.png'),
          imgPath:require('./img/about-3.png'),
          imgTitle:'最短10分で高品質施術',
          //title:'最短10分で<span class="main-color">高品質施術</span>',
          textContent:`最短10分で施術可能。時間を取らないから、好きなときに通える。
しかも、10分でも効果はバツグン！スキマ時間にきれいになろう♪`
        },
      ]
    }
  },
  computed:{
    aboutEnrikeFull:function() { 
      /*
        文章と画像を左右交互に表示したいから
        ここでクラス名をつけて振り分ける
      */
      return this.aboutEnrike.map(function(content,index){
        // p1 = パターン1 
        let contentClass='content-p1'
        let imgClass='about-img-p1'
        let textContentClass='text-content-p1'
        
        if( index % 2 != 0){
          // 要素番号が奇数だったらパターン２を適用
          contentClass='content-p2'
          imgClass='about-img-p2'
          textContentClass='text-content-p2'
        }
        return {
          contentClass:contentClass,
          imgClass: imgClass,
          imgPath: content.imgPath,
          imgTitle: content.imgTitle,
          textContentClass:textContentClass,
          title: content.title,
          textContent: content.textContent
        }
      })
    }
  }
}
</script>

<style>
  @import "../../css/style.css";

  .main-color{
    color: var(--main-color);
  }

  .margin-tb-50{
    margin: 50px auto;
  }

   /* PC表示 */
  @media screen and (min-width:821px){

    
    .about-title{
      color: var(--main-color);
      text-align: center;
      margin:50px auto;
    }

    .title-main{
      font-size: 2.5rem;
      letter-spacing: 0.2em;
    }

    .title-sub{
      font-size: 1rem;
      margin-top: 0.5em;
    }

    /* 外側 */
    .content-p1,.content-p2{
      /*display: flex;*/
      justify-content: center;
      padding: 15px 0;
    }

    .content-p1{
      background-color: #D8EBEE;
    }

    .content-p2{
      background-color: white;
    }

    /* 画像 */
    .about-img-p1,.about-img-p2{
      /* ↓0204変更 */ 
      width:100vw;
      margin:15px;
      object-fit: contain;
      /*height:250px;*/
      height: 400px;
    }

    .about-img-p1{
      order:1;
    }

    .about-img-p2{
      order:2
    }

    /* テキスト */
    .text-content-p1{
      color: black;
      font-size: 1.3rem;
      width: 30vw;
      margin:0 auto;
      margin-bottom:24px;
      line-height: 1.5em;
    }

    .text-content-p2{
      color: black;
      font-size: 1.3rem;
      width: 40vw;
      margin:0 auto;
      margin-bottom:24px;
      line-height: 1.5em;
    }

    .text-content-p1{
      order:2
    }

    .text-content-p2{
      order:1
    }

    .about-text-title{
      color: black;
      font-size: 2rem;
      font-weight: 600;

      margin-bottom: 1em;
      
    }
  }
  /* スマホ表示 */
  @media screen and (max-width:820px){
    .about-title{
      color: var(--main-color);
      text-align: center;
      margin:30px auto 10px auto;
    }

    .title-main{
      font-size: 5vw;
      letter-spacing: 0.2em;
      /*margin-bottom: 0.8em;*/
    }

    .title-sub{
      font-size: 2vw;
      margin-top: 1em;
      
    }

    /* 外側 */
    .content-p1,.content-p2{
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      /*padding:15px 0;*/
      padding-top: 15px;
      padding-bottom:10px;
      margin:20px 0;

     
    }

    .content-p1{
      /*background-color: white;*/
      background-color: #D8EBEE;
    }

    .content-p2{
      background-color: white;
    }

    /* 画像 */
    .about-img-p1,.about-img-p2{
      /*width:80vw;*/
      width:100vw;
      object-fit: contain;
      height: auto;
    }

    .about-img-p1{
      order:1;
    }

    .about-img-p2{
      order:1
    }

    /* テキスト */
    .text-content-p1,.text-content-p2{
      color: black;
      font-size: 3vw;
      width: 80vw;
      margin:15px;

      line-height: 1.5em;
    }

    .text-content-p1{
      order:2
    }

    .text-content-p2{
      order:2
    }

    .about-text-title{
      color: black;
      font-size: 4vw;
      font-weight: 600;

      margin-bottom: 0.5em;
    }
  }
</style>
